// extracted by mini-css-extract-plugin
export default {"truncated":"Tooltip_truncated__gJi8Q","tooltip":"Tooltip_tooltip__ulDbL"};